export enum ContainerType {
  DRAWER = 'drawer',
  MODAL = 'modal',
  TAB = 'tab',
  TOOLTIP = 'tooltip',
  ISLAND = 'island',
}
